import { ApiContext, apiContextFetch } from "../base"

export type PageType = "home" | "client" | "prospect" | "contact" | "business"

export interface LayoutCustomizationResponse {
  id: string
  page_type: PageType
  config: { tab_order: string[] }
  created_at: string
  updated_at: string
}

export async function fetchAllLayoutCustomizations(context: ApiContext): Promise<LayoutCustomizationResponse[]> {
  const response = await apiContextFetch<{ layout_customizations: LayoutCustomizationResponse[] }>(
    context,
    "company/layout_customizations"
  )
  return response.layout_customizations
}

export async function upsertLayoutCustomization(
  context: ApiContext,
  pageType: PageType,
  config: { tab_order: string[] }
): Promise<LayoutCustomizationResponse[]> {
  const response = await apiContextFetch<{ layout_customizations: LayoutCustomizationResponse[] }>(
    context,
    `company/layout_customizations/${pageType}`,
    {
      method: "PUT",
      body: JSON.stringify({
        layout_customization: { config },
      }),
    }
  )
  return response.layout_customizations
}
